<template>
  <v-app :class="appClass">
    <component :is="layout" :component="layout">
      <router-view />
    </component>
    <CustomToaster />
  </v-app>
</template>

<script>
import {mapState} from 'vuex'
import {LANG} from '@/helpers/variables/language'
import MainLayout from './layouts/MainLayout'
import EmptyLayout from './layouts/EmptyLayout'

export default {
  name: 'App',
  components: {MainLayout, EmptyLayout},
  computed: {
    ...mapState({
      locale: (state) => state.locale,
    }),
    layout() {
      return `${this.$route.meta.layout || 'empty'}-layout`
    },
    appClass() {
      return this.locale === LANG.RU ? 'montserrat-family' : ''
    },
  },
}
</script>
